<template>
  <el-form-item
    :class="[
      props.direction === 'vertical' ? 'is-vertical' : 'is-horizontal',
      props.labelStretch ? 'is-label-stretch' : '',
    ]"
    label-width="auto"
    :prop="props.prop"
    :data-prop="props.prop"
    :rules="props.rules"
  >
    <template #label>
      <div
        v-if="props.label"
        class="flex max-w-full"
      >
        <span
          ref="labelRef"
          class="block"
          :class="{
            'pt-2 mt-px': props.direction !== 'vertical',
            'truncate': props.labelTruncate,
          }"
        >
          {{ props.label }}
        </span>
        <el-tooltip
          v-if="isMounted && isLabelTruncated"
          :content="props.label"
          trigger="hover"
          virtual-triggering
          :virtual-ref="labelRef"
        />
        <span
          v-if="showAsterisk"
          class="text-red-500 mx-px hidden [.el-form-item.is-required_&]:block"
        >
          *
        </span>
        <Tooltip
          v-if="props.tooltipText"
          :text="props.tooltipText"
          :image="props.tooltipImage"
          class="ml-1"
          :class="props.direction === 'vertical' ? 'mt-0.5' : 'mt-2.5'"
        />
      </div>
    </template>
    <slot />
  </el-form-item>
</template>

<script setup>
const props = defineProps(buildProps({
  label: {
    type: String,
    default: '',
  },
  tooltipText: {
    type: String,
    default: '',
  },
  tooltipImage: {
    type: String,
    default: undefined,
  },
  direction: {
    type: String,
    values: ['vertical', 'horizontal'],
    default: 'vertical',
  },
  labelStretch: {
    type: Boolean,
    default: false,
  },
  labelTruncate: {
    type: Boolean,
    default: true,
  },
  prop: {
    type: String,
    default: '',
  },
  showAsterisk: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Array,
    default: () => [],
  },
}));

// Refs
const labelRef = ref(null);
const isMounted = useMounted();

// Computed
const isLabelTruncated = computed(() => {
  if (props.labelTruncate && props.label && isMounted.value) {
    return labelRef.value?.scrollWidth > labelRef.value?.clientWidth;
  }

  return false;
});
</script>
